import { ApiClientError } from './api-client'

/** 只保存排查所需的元数据，不复制表单内容、请求体或凭据。 */
export function describeFailure(error: unknown, context: { action: string; object: string; app?: string; version?: string }) {
  const { action, object } = context
  const failure = error instanceof ApiClientError ? error : null
  let message = error instanceof Error ? error.message : `${object}没有${action}，请稍后再试。`
  if (failure?.kind === 'network') message = `网络连接中断，${object}没有${action}。检查网络后再点${action}。`
  else if (failure?.kind === 'timeout') message = `服务器长时间没有响应，${object}可能没有${action}。请刷新页面确认后再试。`
  else if (failure?.kind === 'http') {
    if (failure.status === 413) message = '文件超过服务器上限，请压缩后重传。'
    else if ([502, 503, 504].includes(failure.status)) message = '服务正在重启或暂时不可用，请 1 分钟后再试。'
    else message = `服务器返回了无法识别的响应（HTTP ${failure.status}），${object}没有${action}。`
  } else if (failure && failure.status >= 500) {
    message = `${object}没有${action}：${failure.message}。你填的内容还在，可以稍后再点${action}；反复失败请把排查编号发给管理员。`
  }
  const requestId = failure?.requestId
  const version = context.version ?? (typeof document === 'undefined' ? undefined : document.querySelector('[aria-label^="版本信息"]')?.textContent?.trim())
  const diagnostics = [
    `时间：${new Date().toLocaleString()}（UTC${new Date().getTimezoneOffset() <= 0 ? '+' : '-'}${Math.abs(new Date().getTimezoneOffset()) / 60}）`,
    `应用：${context.app ?? (typeof document === 'undefined' ? 'LeapWorld' : document.title || 'LeapWorld')}`,
    `页面：${typeof location === 'undefined' ? '/' : location.pathname}`,
    `操作：${action}${object}`,
    `HTTP 状态：${failure?.status || '无响应'}`,
    `requestId：${requestId ?? '未提供'}`,
    ...(version ? [`版本：${version}`] : []),
  ].join('\n')
  return { message, requestId: requestId?.slice(0, 8), diagnostics }
}
